require("./subscriptionHistoryController");


"use strict";

angular.module('app.myProfile.subscriptionHistory.subscriptionHistoryDirective', [
    'app.myProfile.subscriptionHistory.subscriptionHistoryController'
])
.directive('subscriptionHistory', [
    function () {
        return {
            restrict: 'EA',
            templateUrl: 'components/myProfile/subscriptionHistory/subscriptionHistoryView.html',
            controller: 'subscriptionHistoryController',
            scope: true
        };
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/subscriptionHistory/subscriptionHistoryDirective.js